<template>
  <div class="row border-bottom white-bg dashboard-header">
    <div class="col-lg-4 col-xl-3">
      <h2>
        Smart Segmentation
        <span class="targeting-badge">+Targeting</span>
      </h2>
    </div>
    <div class="col text-right dashboard-header__actions">
      <el-button size="small" plain @click="$emit('tour')">
        <i class="fa fa-compass"></i> Take a tour
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardHeader',
};
</script>

<style lang="scss" scoped>
.dashboard-header {
  margin-bottom: 35px;
}

.dashboard-header__actions {
  align-self: center;
  padding-right: 20px;
}

.dashboard-header h2 {
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 8px;
}

.targeting-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  padding: 2px 8px;
  border-radius: 10px;
  color: #fff;
  background-color: rgb(20, 179, 147);
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// DashboardHeader.vue?1f5f8ad6